import React from 'react'
import { Toast } from 'react-bootstrap'
import { connect } from 'react-redux';
import { Dispatch, AnyAction } from 'redux';
import { RemoveToasts } from '../../store/actions/actionTypes';
import './toast.css'

interface IProps {
  toasts:[],
  removeToasts: (index: number) => void;
}

const ToastNotification = (props:IProps) => {
 
        // onClose={() => setShow(false)}  show={show}
        return (
          <>
       {props.toasts.map((toast:any,index) =>
        <Toast 
        className={ toast.title==='Success' ? 'toast-success' : 'toast-error'}
        key={index} onClose={() => props.removeToasts(index)} delay={3000} autohide>
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded mr-2"
              alt=""
            />
            <strong className="mr-auto">{toast.title}</strong>
            <small>{toast.subTitle}</small>
          </Toast.Header>
          {toast.message && <Toast.Body>{toast.message}</Toast.Body>}
        </Toast>
        )
    }
    </>

        )}

    const mapStateToProps = (state:any) => ({
      toasts: state.common.toasts
    });

    const mapDispatchToProps = (dispatch:Dispatch<AnyAction>) => {
      return {
        removeToasts : (index: number) =>  dispatch({type: RemoveToasts,payload: index})
      }
    }
    
    
export default connect(mapStateToProps,mapDispatchToProps)(ToastNotification);
